import { Input } from '@arco-design/web-react';
import { CloseOutlined } from '@easyv/react-icons';
import React from 'react';

interface AttrTagProps {
  id: string;
  name: string;
  editingKey: string | undefined;
  onDelete: (id: string) => void;
  onRenameStart: (key: string) => void;
  onRenameEnd: (oldKey: string, newKey: string) => void;
}

export function AttrTag(props: AttrTagProps) {
  const { id, name, editingKey, onDelete, onRenameStart, onRenameEnd } = props;
  const isEditing = id === editingKey;

  return (
    <div className='bg-FFFFFF1F px-2 rounded-sm leading-5 flex items-center gap-x-[6px] h-[22px]'>
      {isEditing ? (
        <Input
          autoFocus
          className='!h-5 !flex !focus:shadow-none !border-none !w-auto'
          maxLength={32}
          defaultValue={name}
          onPressEnter={(e) => {
            e.target.blur();
          }}
          onBlur={(e) => {
            onRenameEnd?.(name, e.target.value);
          }}
        />
      ) : (
        <div
          className='flex items-center justify-between'
          onDoubleClick={() => onRenameStart?.(id)}
        >
          <div className='overflow-scroll no-scroll-container h-full whitespace-nowrap text-white'>
            {name}
          </div>
          <CloseOutlined
            className='cursor-pointer leading-5 flex items-center hover:text-white pl-[6px]'
            onClick={() => {
              onDelete?.(id);
            }}
          />
        </div>
      )}
    </div>
  );
}
